// extracted by css-extract-rspack-plugin
export default {"table":"PositionInfoDialog_table__d9SWZ","right":"PositionInfoDialog_right__1Szav","left":"PositionInfoDialog_left__FTBx0","link":"PositionInfoDialog_link__0xg6+"};